import { Component } from '@angular/core';
import { NavController ,LoadingController} from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';

@Component({
  selector: 'page-about',
  templateUrl: 'about.html'
})


export class AboutPage {
  aboutUsContent: any;

  constructor(public loadingCtrl: LoadingController,private cp: CommonProvider,public navCtrl: NavController) {
    //this.getAboutUsContent()
  }

  ionViewDidLoad() {
    ////console.log('ionViewDidLoad LoginPage');
	this.getAboutUsContent()
  }
   
  getAboutUsContent(){
    let loading = this.loadingCtrl.create({
    content:"Please wait..."
  });
  loading.present();
  let data = this.cp.getAboutUsPage(loading) ;
	data.then((res:any)=>{
    loading.dismiss();
    console.log(res);
     var res=JSON.parse(res)
		 this.aboutUsContent = res.Payload.knowledgearticles[0].content;
     ////console.log(this.aboutUsContent);
     
	})
}
}



// WEBPACK FOOTER //
// ./src/pages/about/about.ts